module.exports = "<div class=\"col-xs-12\">\r\n  <p>\r\n    You are not authorized to view this page. Please login to continue.\r\n  </p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main